<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter1" id="tp">Fire On The Mountain  <br/><br/><br/></p>
<p class="right">Edward Abbey  </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795317392_epub_tp_r1.vue?076d6952